import schema from './schemaVersions/v23.js';
	const finalSchema = { wip: false, ...schema };
	export default finalSchema;